/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vx-card class="p-4">
          <div class="flex justify-end items-center pl-24 mb-4">
            <h4 class="p-3 rounded-lg mr-2" style="background: rgba(0, 0, 0, 0.26)">
              Hello, this is John Smith from Real Email, How may i help you today!
            </h4>
            <img src="https://rapidsimulations.com/simulations/12/images/operator.png" alt="" width="50" class="ml-2" />
          </div>
          <div class="flex justify-start items-center pr-24 mb-4">
            <img src="https://rapidsimulations.com/simulations/12/images/person-1.png" alt="" width="50" class="mr-2" />
            <h4 class="p-3 rounded-lg ml-2" style="background: rgba(0, 0, 0, 0.26)">
              Hello How are you, I cannot receive emails, could you look into as why this is?
            </h4>
          </div>
          <div class="flex justify-start items-center pr-24 mb-4">
            <img src="https://rapidsimulations.com/simulations/12/images/person-1.png" alt="" width="50" class="mr-2" />
            <h4 class="p-3 rounded-lg ml-2" style="background: rgba(0, 0, 0, 0.26)">Here is a screenshot of my settings.</h4>
          </div>
          <div class="flex justify-start items-center pr-24 mb-4">
            <img src="https://rapidsimulations.com/simulations/12/images/person-1.png" alt="" width="50" class="mr-2" />
            <img src="https://rapidsimulations.com/simulations/12/images/incomingserver.png" alt="" class="ml-2" width="350" />
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/2">
        <vx-card>
          <h1 class="font-bold">Which one of the following should be done next?</h1>
          <vs-button
            color="primary"
            type="border"
            class="w-full mt-4"
            size="large"
            icon="icon-play"
            icon-pack="feather"
            @click="markSimulation"
          >
            Educate the user on the solution that was performed
          </vs-button>
          <vs-button
            color="primary"
            type="border"
            class="w-full mt-4"
            size="large"
            icon="icon-play"
            icon-pack="feather"
            @click="incorrectOption"
          >
            Send an email to Telecom to inform them of the issue
          </vs-button>
          <vs-button
            color="primary"
            type="border"
            class="w-full mt-4"
            size="large"
            icon="icon-play"
            icon-pack="feather"
            @click="incorrectOption"
          >
            Tell the user to take time to fix it themselves next time
          </vs-button>
          <vs-button
            color="primary"
            type="border"
            class="w-full mt-4"
            size="large"
            icon="icon-play"
            icon-pack="feather"
            @click="incorrectOption"
          >
            Close the ticket out
          </vs-button>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
    };
  },
  methods: {
    incorrectOption() {
      this.$vs.notify({
        title: 'Incorrect Option',
        text: 'Select the correct action to do next.',
        color: 'danger',
        iconPack: 'feather',
        icon: 'icon-x-circle',
        position: 'top-right',
      });
    },
    markSimulation() {
      return this.$emit('simulation_full_correct', 1);
    },
  },
  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/views/platform/modules/simulations/legacy/css/CompTIA/Security+/Lgx201394311844069376.scss';

button.vs-tabs--btn {
  color: #ffffff;
}
</style>
